/* eslint-disable */
export default {
  dial: '전화 걸기',
  message: '메시지',
  transfer: '전달',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
